



















import Vue from "vue";
import StatisticsPage from "@/components/StatisticsPage.vue";
import userHts from "@/constants/userHts";

export default Vue.extend({
  components: { StatisticsPage },
  data() {
    return {
      month: parseInt(this.$route.params.month, 10),
      htPickerOptions: {
        label: "Hình thức làm việc",
        clearable: true,
        items: Object.entries(userHts).map(([value, text]) => ({ value, text })),
      },
    };
  },
});
